import React, { useEffect, useState } from 'react';
import entranceService from '../../../services/operation/entrance.service';
import {Space, Tag, Table} from 'antd';
import moment from 'moment';
import MerchantService from "../../../services/ewallet_integration/merchant.service";
import CustomerService from "../../../services/ewallet_integration/customer.service";
import serviceHelper from "../../../helpers/functions/service.helper";

const MerchantListTable = ({ filter, }) => {
    const [state, setState] = useState({
        loading : false,
        rows : [],
        total_balance: 0,

        // refresh
        refresh : 0,

        // pagination
        page : 1,
        display_size : 10,
        count : null,
    })

    const columns = [
        {
            title: "Name",
            dataIndex: 'name',
            key: "name",
        },
        {
            title: "Wallet",
            dataIndex: ["wallet", "name"], // works for nested: from_wallet.name
            key: "wallet_name",
        },
        {
            title: "Last Updated",
            dataIndex: ["wallet","updated_at"],
            key: "updated_at",
            render: (updated_at) => <span>{moment(updated_at)?.format("YYYY-MM-DD hh:mm:ssa")}</span>,
        },
        {
            title: "Melon Balance",
            dataIndex: ['wallet', 'melon_balance'],
            key: "melon_balance",
            align: 'right',
            render: (melon) => melon ? Number(melon).toFixed(2) : "0.00",
        },
    ];

    const paginateChange = (key, value) => {
        // set state
        setState(state => ({...state, [key] : value}));

        let generate_filter = filter;
        generate_filter[key] = value;
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    }

    const fetchReport = async () => {
        setState(state => ({...state, loading : true, }));
        const { option_value, } = filter;
        const response = await MerchantService?.melon_merchants({
            // pagination
            page : state?.page,
            size : state?.display_size,

            // order
            order : "created_at",
            order_position : 'ASC',
        });
        const {  merchants, total_balance} = response?.data;
        const {rows, count} = merchants
        setState(state => ({...state, loading : false, rows, count, total_balance  }));
    }

    useEffect(() => {
        fetchReport();
    }, [filter, state?.page])

    return (
        <>
            <h3>Total Balance : {Number(state.total_balance).toFixed(2)}</h3>
            <Table
                scroll={{ x : 400, }}
                size='small'
                pagination={{
                    pageSize : state?.display_size,
                    current : (state?.count > state?.display_size) ? state?.page : 1,
                    total : state?.count,
                    showSizeChanger: false,
                    onChange : (page) => paginateChange('page', page)
                }}
                className='hub-table bordered'
                dataSource={state?.rows}
                columns={columns}
                rowKey="merchant_id"
            />
        </>
    );
}

export default MerchantListTable;